import { IApplicationState } from '../../types/redux';

export function selectWebimInfo(state: IApplicationState) {
  return state.webim;
}
